import { Component } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
// Service
import { OrderInboxService } from '../../service/order-inbox.service';
import { BroadcastService } from '@cv-invision/core';
import { UCDPOverrideComponent } from '../../../shared/ucdp-override/ucdp-override.base';

@Component({
    selector: 'cv-cu-score-dialog',
    templateUrl: '../../../shared/ucdp-override/ucdp-override.base.html',
    styleUrls: ['../../../shared/ucdp-override/ucdp-override.base.scss'],
})
export class CUScoreOverwriteDialogComponent extends UCDPOverrideComponent {

    constructor(
        protected override inboxService: OrderInboxService,
        protected override broadcastService: BroadcastService,
        protected override dialogRef: DynamicDialogRef,
        protected override dialogConfig: DynamicDialogConfig,
    ) {
		super(inboxService, broadcastService, dialogRef, dialogConfig);
	}
}
